import { render, staticRenderFns } from "./StatsLapsDetails.vue?vue&type=template&id=37875a10&"
import script from "./StatsLapsDetails.vue?vue&type=script&lang=js&"
export * from "./StatsLapsDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatsLapsDetails.vue?vue&type=style&index=0&id=37875a10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports